/**
 * Fills array with data
 */
export function fillArr<T>(count: number, mapper: (i: number) => T): T[] {
  return Array(count)
    .fill(null)
    .map((item, i) => mapper(i + 1));
}
